var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 64,
    viewBox: "0 0 152 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 64,
    rx: 4,
    fill: "#D73B3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 152,
    height: 64
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 64,
    rx: 4,
    fill: "#D73B3B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_388)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 69.2401,
    width: 182.522,
    height: 72.8274,
    transform: "rotate(-15 40 69.2401)",
    fill: "#C53333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.1822,
    y: 63.0285,
    width: 12,
    height: 11.9844,
    transform: "rotate(-15 63.1822 63.0285)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.3644,
    y: 56.8168,
    width: 12,
    height: 11.9844,
    transform: "rotate(-15 86.3644 56.8168)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.547,
    y: 50.6052,
    width: 12,
    height: 11.9844,
    transform: "rotate(-15 109.547 50.6052)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.729,
    y: 44.3935,
    width: 12,
    height: 11.9844,
    transform: "rotate(-15 132.729 44.3935)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.422,
    y: 52.8637,
    width: 12,
    height: 11.9844,
    transform: "rotate(-15 147.422 52.8637)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.24,
    y: 59.0753,
    width: 12,
    height: 11.9844,
    transform: "rotate(-15 124.24 59.0753)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.057,
    y: 65.287,
    width: 12,
    height: 11.9844,
    transform: "rotate(-15 101.057 65.287)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.008 40H34.72L41.896 23.2L42.16 23.08L48.208 40H46.168L44.296 34.72H37.288L35.008 40ZM41.152 25.792L37.384 34.48H44.224L41.152 25.792ZM57.8153 40H48.6953V23.2H50.6873V39.76H57.8153V40ZM69.364 23.2H69.676V32.8C69.676 35.312 69.18 37.16 68.188 38.344C67.196 39.512 65.9 40.096 64.3 40.096C63.292 40.096 62.436 40.008 61.732 39.832C61.028 39.64 60.364 39.296 59.74 38.8C58.46 37.808 57.82 35.808 57.82 32.8V23.2H59.812V32.776C59.812 35.688 60.252 37.632 61.132 38.608C61.58 39.088 62.044 39.416 62.524 39.592C63.02 39.768 63.612 39.856 64.3 39.856C65.836 39.856 67.06 39.296 67.972 38.176C68.9 37.04 69.364 35.24 69.364 32.776V23.2ZM70.9994 23.392C72.8554 23.264 74.4954 23.2 75.9194 23.2C79.8714 23.2 81.8474 24.52 81.8474 27.16C81.8474 28.28 81.5754 29.28 81.0314 30.16C80.4874 31.04 79.5514 31.624 78.2234 31.912L83.0234 40H80.7914L76.0874 32.056H72.9914V40H70.9994V23.392ZM75.9194 23.44C74.9914 23.44 74.0154 23.496 72.9914 23.608V31.816H76.5434C78.7994 31.72 79.9274 30.184 79.9274 27.208C79.9274 25.992 79.5914 25.064 78.9194 24.424C78.2474 23.768 77.2474 23.44 75.9194 23.44ZM82.5269 32.008C82.5269 29.096 83.2309 26.888 84.6389 25.384C86.0629 23.864 87.8869 23.104 90.1109 23.104C92.3349 23.104 94.1029 23.76 95.4149 25.072C96.7429 26.384 97.4069 28.48 97.4069 31.36C97.4069 34.24 96.7029 36.416 95.2949 37.888C93.8869 39.36 92.0069 40.096 89.6549 40.096C87.6229 40.096 85.9589 39.512 84.6629 38.344C83.9909 37.736 83.4629 36.896 83.0789 35.824C82.7109 34.736 82.5269 33.464 82.5269 32.008ZM90.0389 23.344C88.4229 23.344 87.0949 24.064 86.0549 25.504C85.0309 26.944 84.5189 29.056 84.5189 31.84C84.5189 34.624 85.0069 36.656 85.9829 37.936C86.9589 39.216 88.2549 39.856 89.8709 39.856C91.5029 39.856 92.8309 39.136 93.8549 37.696C94.8949 36.24 95.4149 34.136 95.4149 31.384C95.4149 28.616 94.9189 26.584 93.9269 25.288C92.9509 23.992 91.6549 23.344 90.0389 23.344ZM98.5579 40H98.2459V23.2H99.0619L109.046 38.728V23.2H109.358V40H107.606L98.5579 26.08V40ZM110.912 23.44V23.2H115.184V23.44H114.008V39.76H115.184V40H110.912V39.76H112.016V23.44H110.912Z",
    fill: "#FAFAFA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4aa691b6070b74b5f57b342792fde93d.svg";
export { ForwardRef as ReactComponent };